<template>
  <v-app id="inspire">
    <v-card class="mx-auto" max-width="100%">
      <v-container>
        <v-row dense>
          <v-col cols="12">
            <v-card color="#385F73" dark>
              <v-card-title class="headline">
                Misión:
              </v-card-title>

              <v-card-text>
                <p>
                  * Elaborar la visión compartida: Visión, valores, misión con
                  la participación de todas las áreas.
                </p>
                <p>
                  * Definir las áreas de producto-mercado donde operará la
                  empresa.
                </p>
                <p>
                  * Definir los objetivos y metas generales y estratégicas.
                </p>
                <p>
                  * Definir la estructura organizacional.
                </p>
                <p>
                  * Definir la estructura e infraestructura necesaria para
                  desarrollar las actividades.
                </p>
                <p>
                  * Asegurar los recursos financieros.
                </p>
                <p>
                  * Realizar el planeamiento estratégico y sus actualizaciones.
                </p>
                <p>
                  * Planificar, organizar, coordinar, gestionar y controlar los
                  factores de producción (bienes transformables, factores de
                  trabajo, infraestructura, maquinarias, servicios), factores
                  mercadotécnicos y factores financieros, para alcanzar los
                  objetivos generales y estratégicos.
                </p>
                <p>
                  * Liderar, motivar y comunicar para hacer eficaz y eficiente
                  la gestión.
                </p>
                <p>
                  * Propender a la creación de un ambiente de trabajo que
                  fomente el desarrollo de las potencialidades del personal, su
                  creatividad e iniciativa. Potenciar la autoridad de
                  responsables en la toma de decisiones.
                </p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <v-container>
        <v-row dense>
          <v-col v-for="(item, i) in listado" :key="i" cols="12" md="6" lg="4">
            <v-card :color="colorCumplimiento(item.valoractual)">
              <v-card-title>Objetivo: {{ item.codgral }}</v-card-title>

              <v-card-text>
                <div><strong>Descr.:</strong> {{ item.objetivo }}</div>
                <div><strong>Tipo:</strong> {{ item.tipo }}</div>

                <div>
                  <strong>Meta:</strong>
                  <pre class="meta">{{ item.meta }}</pre>
                </div>

                <div><strong>Indicador:</strong> {{ item.indicador }}</div>
                <div><strong>Responsable:</strong> {{ item.responsable }}</div>
                <div><strong>Cumplimiento:</strong> {{ item.cumplimiento }}%</div>
                <div><strong>Valor Indic / Referencia:</strong> {{ item.valoractual }} / {{
                  item.referencia }}</div>
                <div><strong>Plan:</strong> {{ item.plan }}</div>
                <div><strong>Observaciones:</strong> {{ item.observ }}</div>

                <div>
                  <strong>Fecha de Actualización:</strong>
                  {{ item.fecha }}
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-app>
</template>
<style>
.meta {
  white-space: pre-wrap;
  /* ← Para permitir varias líneas */
  font-family: inherit;
}
</style>
<script>
import axios from "../../axios-auth.js";
import moment from "moment";

export default {
  data: () => ({
    usuario: null,
    now: moment(),
    diferencia: "",
    listado: [],
  }),
  watch: {},
  created() {
    this.usuario = this.$store.state.usuario.toString().trim();
    this.cargarListado();
  },
  mounted() {
    if (this.$store.state.usuario == "" || this.$store.state.usuario == null) {
      this.$store.dispatch("logout");
    } else {
      this.$store.state.sector = "Direccion";
      //  this.cargaraccidentes();
    }
  },
  methods: {
    colorCumplimiento(item) {
      if (item != null && item != "") {
        if (item == "0") {
          return "red";
        }
        if (item == "100") {
          return "green";

        }
        if (item.replace(",", ".") > 0 && item.replace(",", ".") < 100) {
          return "yellow";
        }
      }
    },

    cargarListado() {
      this.loadtable = true;
      const codgral = "";
      const periodo = "";
      const objetivo = "";
      const meta = "";
      const indicador = "";
      const responsable = "";
      const area = "Dirección";
      const tipo = "";
      const asociado = "";

      let self = this;
      axios
        .get("/Indicadores/ListadoObjetivos?", {
          params: {
            codgral: codgral,
            periodo: periodo,
            objetivo: objetivo,
            indicador: indicador,
            responsable: responsable,
            meta: meta,
            asociado: asociado,
            area: area,
            tipo: tipo,

          },
        })
        .then((response) => {
          self.listado = response.data;
          self.loadtable = false;
          console.log(self.listado)
        })
        .catch((error) => {
          self.listado = [];
          console.log(error);
        });
    },
  },
};
</script>
